import { render, staticRenderFns } from "./NewDish.vue?vue&type=template&id=44cca714&"
import script from "./NewDish.vue?vue&type=script&lang=js&"
export * from "./NewDish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports